import { render, staticRenderFns } from "./TextWithIconOverlay.vue?vue&type=template&id=7f78b7f8"
import script from "./TextWithIconOverlay.vue?vue&type=script&lang=js"
export * from "./TextWithIconOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports